import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {InvoiceImportItemLedgerAccountMapping, InvoiceImportItemMapping} from "@app/shared/classes/dataimport/invoice-import-item";
import {
  AccountMappingType,
  AccountService,
  AccountTypeName,
  ChargeCode,
  ChargeCodeService,
  ChargeCodeType,
  CommonTransformationService,
  DateService,
  FileService,
  Format,
  GrowlType,
  ItemType,
  PrimeNgConfig,
  PrimeNgSupportService,
  TableColumn,
  Transaction,
  Validation
} from "@app/shared";
import {ConfirmationService, SelectItem} from "primeng/api";
import {ImportDataService} from "@app/shared/import/data-import/import-data.service";
import {QuickBooksImportDataService} from "@app/finance/time/quickbooks/quick-books-import-data.service";
import {GrowlService} from "@app/core";
import {plainToClass} from "class-transformer";
import {forkJoin} from "rxjs/internal/observable/forkJoin";

@Component({
  selector: 'app-invoice-item-mappings',
  templateUrl: './invoice-item-mappings.component.html',
  styleUrls: ['./invoice-item-mappings.component.css']
})
export class InvoiceItemMappingsComponent implements OnInit {

  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  itemMappings: InvoiceImportItemMapping[]
  tableColumns: TableColumn[] = [];
  chargeCodeDropDown: SelectItem<number>[] = [];
  codeTypeDropDown: SelectItem<ChargeCodeType>[] = [];
  itemTypeDropDown: SelectItem<ItemType>[] = [];

  chargeCodes: ChargeCode[] = [];


  cogsAccountDropdown: SelectItem<number>[];                    // list of COGS accounts retrieved from backend
  incomeAccountDropdown: SelectItem<number>[];                  // list of income accounts retrieved from backend
  fixedAssetAccountDropdown: SelectItem<number>[];              // list of fixed asset accounts retrieved from backend
  inventoryAccountDropdown: SelectItem<number>[];               // list of asset accounts dropdown
  assetAccountDropdown: SelectItem<number>[];                   // list of asset accounts dropdown
  otherCurrentAssetAccountDropdown: SelectItem<number>[];       // list of asset accounts retrieved from backend
  otherAssetAccountDropdown: SelectItem<number>[];              // list of asset accounts retrieved from backend
  operationalExpenseAccountDropdown: SelectItem<number>[];      // list of operational expense account retrieved from backend
  unallowableAccountDropdown: SelectItem<number>[];             // list of unallowable accounts
  dropDownMap: Map<AccountMappingType, SelectItem<number>[]> = new Map<AccountMappingType, SelectItem<number>[]>();




  @ViewChild('itemTypeTemplate') itemTypeTemplate: TemplateRef<any>;
  @ViewChild('codeTypeTemplate') codeTypeTemplate: TemplateRef<any>;

  @ViewChild('ledgerAccountTemplate') ledgerAccountTemplate: TemplateRef<any>;

  constructor(private importService: ImportDataService, private ccDataService: ChargeCodeService,
              private qbImportSerive: QuickBooksImportDataService,
              private primeNgService: PrimeNgSupportService,  private fileService: FileService, private dateService: DateService,
              private transformationService: CommonTransformationService,
              private accountService: AccountService,
              private confirmationService: ConfirmationService,
              private growl: GrowlService) { }

  ngOnInit(): void {

    this.buildDropDowns();
    this.getItemMappings();

  }

  ngAfterViewInit(): void {
    this.buildTableColumns();
  }


  importItemMappings() {
    this.importService.importInvoiceItemMappings().subscribe(res => {
      this.getItemMappings();
    })
  }

  getItemMappings() {
    this.importService.getInvoiceItemMappings().subscribe(res => {
      this.itemMappings = plainToClass(InvoiceImportItemMapping, res);
    });
  }

  onClickAddItems(){
    this.importService.addItemsToCatalog().subscribe(res => {
      this.getItemMappings();
      this.growl.add(GrowlType.Success, "Items added successfully");
    });
  }

  onChangeItemOrCodeType(itemMapping: InvoiceImportItemMapping) {
    if(itemMapping.itemType && itemMapping.codeType){
      let existingMapping = this.itemMappings.find(i => i=== itemMapping);
      if(existingMapping){
        existingMapping.accountMappings = [];
      }
      this.accountService.getRequiredAccountTypes(itemMapping?.itemType, itemMapping?.codeType, Transaction.VendorInvoice).subscribe(res => {
        let mappingTypes: AccountMappingType[] = res;
        mappingTypes.forEach(m => {
          let mapping: InvoiceImportItemLedgerAccountMapping = new InvoiceImportItemLedgerAccountMapping();
          mapping.codeType = itemMapping?.codeType;
          mapping.itemType = itemMapping?.itemType;
          mapping.accountMappingType = m;
          if(existingMapping){
            existingMapping.accountMappings.push(mapping);
          }
        });
        this.itemMappings = [...this.itemMappings];
      });
    }
  }

  onClickSaveMappings() {
    let validMappings: InvoiceImportItemMapping [] = [];
    // validMappings = this.vendorMappings.filter(map => map?.userId);
    this.importService.saveInvoiceItemMappings(this.itemMappings).subscribe(res => {
      // Since front end sent only valid mappings, get the values again so that all users are displayed.
      this.getItemMappings();
    })
  }

  private buildDropDowns(): void {
    this.codeTypeDropDown =  this.transformationService.convertEnumToDropDown(ChargeCodeType, false, null, true);
    this.itemTypeDropDown =  this.transformationService.convertEnumToDropDown(ItemType, false, null, true);
    forkJoin(
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.COGS, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.Income, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.Inventory, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.FixedAsset, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.OtherCurrentAsset, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.OtherAsset, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.OperationalExpense, null, null, true, true, true),
      this.accountService.getLedgerAccountsAsDropDown(null, AccountTypeName.Unallowable, null, null, true, true, true),

    ).subscribe((
      [cogsAccountDropDown, incomeAccountDropDown, inventoryAccountDropdown, fixedAssetAccountDropDown,
        otherCurrentAssetAccountDropDown, otherAssetAccountDropDown, operationalExpenseAccountDropDown,
        unallowableAccountDropDown]) => {
      this.cogsAccountDropdown = <SelectItem<number>[]>cogsAccountDropDown;
      this.incomeAccountDropdown = <SelectItem<number>[]>incomeAccountDropDown;
      this.inventoryAccountDropdown = <SelectItem<number>[]>inventoryAccountDropdown;
      this.fixedAssetAccountDropdown = <SelectItem<number>[]>fixedAssetAccountDropDown;
      this.otherCurrentAssetAccountDropdown = <SelectItem<number>[]>otherCurrentAssetAccountDropDown;
      this.otherAssetAccountDropdown = <SelectItem<number>[]>otherAssetAccountDropDown;
      this.operationalExpenseAccountDropdown = <SelectItem<number>[]>operationalExpenseAccountDropDown;
      this.unallowableAccountDropdown = <SelectItem<number>[]>unallowableAccountDropDown;


      this.dropDownMap.set(AccountMappingType.Cogs, this.cogsAccountDropdown);
      this.dropDownMap.set(AccountMappingType.Income, this.incomeAccountDropdown);
      this.dropDownMap.set(AccountMappingType.Inventory, this.inventoryAccountDropdown);
      this.dropDownMap.set(AccountMappingType.FixedAsset, this.fixedAssetAccountDropdown);
      this.dropDownMap.set(AccountMappingType.OtherCurrentAsset, this.otherCurrentAssetAccountDropdown);
      this.dropDownMap.set(AccountMappingType.OperationalExpense, this.operationalExpenseAccountDropdown);
      this.dropDownMap.set(AccountMappingType.Unallowable, this.unallowableAccountDropdown);
    });
  }

  private buildTableColumns(): void {
    this.tableColumns = [
      {field: 'displayLabel', header: 'External System Item'},
      {field: 'expenseAccount', header: 'Account'},
      {field: 'codeType', header: 'Code Type', template: this.codeTypeTemplate},
      {field: 'itemType', header: 'Item Type', template: this.itemTypeTemplate},
      {field: 'accountMappings', header: 'Account Mappings', template: this.ledgerAccountTemplate},
    ];
  }

}
